import type { CSSObject } from "type/tss";

export const styles = () => {
	return {
		container: {
			display: "flex",
			flexDirection: "column",
			gap: 12,
		},
	} satisfies Record<string, CSSObject>;
};
